import * as ko from "knockout"
import { ElementLocationViewModel } from "../ElementLocationViewModel"
import { StylesViewModel } from "./StylesViewModel"

export class LabelElementViewModel extends ElementLocationViewModel {
    text: KnockoutObservable<string>;
    styles: KnockoutObservable<StylesViewModel>

    constructor(elementType: string) {
        super(elementType);
        this.text = ko.observable("");
        this.rowSpan(1);
        this.styles = ko.observable(new StylesViewModel());
    }

    protected onSetElementMostLikelyChangedSize() {
        this.text.subscribe(newValue => this.elementMostLikelyChangedSize());
        this.styles().fontSize.subscribe(newValue => this.elementMostLikelyChangedSize());
        this.styles().fontFamily.subscribe(newValue => this.elementMostLikelyChangedSize);
    }

    setColumnSpan(span: number) {
        this.columnSpan(span);
        this.rowSpan(1);
    }

    public clone(): ElementLocationViewModel {
        let ret = new LabelElementViewModel(this.elementType);
        super.cloneThis(ret);

        ret.text(this.text());
        ret.styles(this.styles().clone());

        return ret;
    }

    public getData(data): any {
        super.getData(data);
        data.text = this.text;
        data.styles = this.styles;
    }
}


// WEBPACK FOOTER //
// ./code/elements/LabelElementViewModel.ts